export interface RegistrationUser {
  id: string;
  title: string;
  firstName: string;
  lastName: string;
  nationalId: string;
  email: string;
  phone: string;
  mobilePhone: string;
  comment: string;
  login: string;
  password: string;
  idSpeciality: number | null;
  labelSpeciality: string;
  idProfession: number | null;
  labelProfession: string;
  CGU: boolean;
  validData: boolean;
  newsletter: boolean;

  additionalFields: { [key: string]: string };
  attachmentFields: { [key: string]: File };
  additionalCheckboxes: { [key: string]: string };
}

export class RegistrationUserImpl implements RegistrationUser {
  constructor(
    id?: string,
    title?: string,
    firstName?: string,
    lastName?: string,
    nationalId?: string,
    email?: string,
    phone?: string,
    mobilePhone?: string,
    comment?: string,
    login?: string,
    password?: string,
    idSpeciality?: number | null,
    labelSpeciality?: string,
    idProfession?: number | null,
    labelProfession?: string
  ) {
    this.id = id || "";
    this.title = title || "";
    this.firstName = firstName || "";
    this.lastName = lastName || "";
    this.nationalId = nationalId || "";
    this.email = email || "";
    this.phone = phone || "";
    this.mobilePhone = mobilePhone || "";
    this.comment = comment || "";
    this.login = login || "";
    this.password = password || "";
    this.idSpeciality = idSpeciality || null;
    this.labelSpeciality = labelSpeciality || "";
    this.idProfession = idProfession || null;
    this.labelProfession = labelProfession || "";

    this.CGU = false;
    this.validData = false;
    this.newsletter = false;

    this.additionalFields = {};
    this.attachmentFields = {};
    this.additionalCheckboxes = {};
  }

  id = "";
  title = "";
  firstName = "";
  lastName = "";
  nationalId = "";
  email = "";
  phone = "";
  mobilePhone = "";
  comment = "";
  login = "";
  password = "";
  idSpeciality: number | null = null;
  labelSpeciality = "";
  idProfession: number | null = null;
  labelProfession = "";
  CGU = false;
  validData = false;
  newsletter = false;

  additionalFields: { [key: string]: string } = {};
  attachmentFields: { [key: string]: File } = {};
  additionalCheckboxes: { [key: string]: string } = {};
}
